import { render, staticRenderFns } from "./BreadcrumbColor.vue?vue&type=template&id=5199f2de&"
import script from "./BreadcrumbColor.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports